import { render, staticRenderFns } from "./participateinHelp.vue?vue&type=template&id=2ca45286&scoped=true"
import script from "./participateinHelp.vue?vue&type=script&lang=js"
export * from "./participateinHelp.vue?vue&type=script&lang=js"
import style0 from "./participateinHelp.vue?vue&type=style&index=0&id=2ca45286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca45286",
  null
  
)

export default component.exports